import { Injectable } from '@angular/core';
import { Presupartienc } from "../coninterfaces/conencpresuparti";
import { Presupartidet } from '../coninterfaces/condetpresuparti';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { HttpClient } from '@angular/common/http';
import { Usuario } from '../../usuario';
import { Observable } from 'rxjs';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import Decimal from 'decimal.js';

@Injectable({
  providedIn: 'root'
})
export class ConpartidapresuService {
  public encabezadoPartipresuSelectarray: Presupartienc[] = [];
  public way: string;

  public _detpartipresupuestoarray: Presupartidet[] = [];
  get detpartipresupuestoarray(): Presupartidet[] {
    return this._detpartipresupuestoarray;
  }
  set detpartipresupuestoarray(value: Presupartidet[]) {
    this._detpartipresupuestoarray = value;
  }

  constructor(
    private http: HttpClient,
    public usuario: Usuario,
    private confIniciales: ConfInicialesService,
    private utilitariosService: UtilitariosService
  ) {
    this.way = sessionStorage.getItem('way');
  }


  getencparpre(stranio) {
    return this.http.post<any[]>(this.way + '/cont/parpre/83baebb32ade780', {
      elementos: {
        p_encparpre_anio: stranio,
        p_COM_CODIGO: '01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetparpre(stranio) {
    return this.http.post<any[]>(this.way + '/cont/parpre/83bad7772ade780', {
      elementos: {
        p_encparpre_anio: stranio,
        p_COM_CODIGO: '01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertaencparpre(item) {
    return this.http.post<any[]>(this.way + '/cont/parpre/95f8edf54ebb30000000', {
      elementos: {
        p_encparpre_anio: item.ENCPARPRE_ANIO,
        p_encparpre_comentario: item.ENCPARPRE_COMENTARIO,
        p_com_codigo: '01',
        p_encparpre_estado: item.ENCPARPRE_ESTADO,
        p_usuidentificacion: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizaencparpre(item) {
    return this.http.post<any[]>(this.way + '/cont/parpre/a676b2', {
      elementos: {
        p_encparpre_anio: item.ENCPARPRE_ANIO,
        p_encparpre_comentario: item.ENCPARPRE_COMENTARIO,
        p_com_codigo: '01',
        p_encparpre_estado: item.ENCPARPRE_ESTADO,
        p_usuidentificacion: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertadetparpre(item) {
    return this.http.post<any[]>(this.way + '/cont/parpre/95f8edf54d7770000000', {
      elementos: {
        p_encparpre_anio: item.ENCPARPRE_ANIO,
        p_detparpre_numero: item.DETPARPRE_NUMERO,
        p_detparpre_nombre: item.DETPARPRE_NOMBRE,
        p_DETPARPRE_01: item.DETPARPRE_01,
        p_DETPARPRE_02: item.DETPARPRE_02,
        p_DETPARPRE_03: item.DETPARPRE_03,
        p_DETPARPRE_04: item.DETPARPRE_04,
        p_DETPARPRE_05: item.DETPARPRE_05,
        p_DETPARPRE_06: item.DETPARPRE_06,
        p_DETPARPRE_07: item.DETPARPRE_07,
        p_DETPARPRE_08: item.DETPARPRE_08,
        p_DETPARPRE_09: item.DETPARPRE_09,
        p_DETPARPRE_10: item.DETPARPRE_10,
        p_DETPARPRE_11: item.DETPARPRE_11,
        p_DETPARPRE_12: item.DETPARPRE_12,
        p_detparpre_total: item.DETPARPRE_TOTAL,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizadetparpre(item) {
    return this.http.post<any[]>(this.way + '/cont/parpre/299df2ab2', {
      elementos: {
        p_encparpre_anio: item.ENCPARPRE_ANIO,
        p_detparpre_numero: item.DETPARPRE_NUMERO,
        p_detparpre_nombre: item.DETPARPRE_NOMBRE,
        p_DETPARPRE_01: item.DETPARPRE_01,
        p_DETPARPRE_02: item.DETPARPRE_02,
        p_DETPARPRE_03: item.DETPARPRE_03,
        p_DETPARPRE_04: item.DETPARPRE_04,
        p_DETPARPRE_05: item.DETPARPRE_05,
        p_DETPARPRE_06: item.DETPARPRE_06,
        p_DETPARPRE_07: item.DETPARPRE_07,
        p_DETPARPRE_08: item.DETPARPRE_08,
        p_DETPARPRE_09: item.DETPARPRE_09,
        p_DETPARPRE_10: item.DETPARPRE_10,
        p_DETPARPRE_11: item.DETPARPRE_11,
        p_DETPARPRE_12: item.DETPARPRE_12,
        p_detparpre_total: item.DETPARPRE_TOTAL,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarregistro(stranio) {
    return this.http.post<any[]>(this.way + '/cont/parpre/eacad2ba94ebb00000000', {
      elementos: {
        p_encparpre_anio: stranio,
        p_COM_CODIGO: '01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  cambiarestadoparpre(stranio, estado) {
    return this.http.post<any[]>(this.way + '/cont/parpre/a675dcea9b8ca80000000', {
      elementos: {
        p_encparpre_anio: stranio,
        p_com_codigo: '01',
        p_estado: estado,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  obtenerClave(): Observable<any> {
    return this.http.post<any>(this.way + '/cont/parpre/jwn7qmo1cc3b6ih', {
      elementos: {},
    }, this.confIniciales.httpOptions());
  }

  sumarTotal(index, columna) {
    let item: Presupartidet = this.detpartipresupuestoarray[index]
    let sumatotal = new Decimal(0)
    this.detpartipresupuestoarray[index][columna] = this.utilitariosService.formatear(this.detpartipresupuestoarray[index][columna], 2)
    //Number(this.detpartipresupuestoarray[index][columna]).toFixed(2)
    sumatotal = sumatotal.plus(item.DETPARPRE_01).plus(item.DETPARPRE_02).plus(item.DETPARPRE_03).plus(item.DETPARPRE_04)
      .plus(item.DETPARPRE_05).plus(item.DETPARPRE_06).plus(item.DETPARPRE_07).plus(item.DETPARPRE_08) 
    .plus(item.DETPARPRE_09).plus(item.DETPARPRE_10).plus(item.DETPARPRE_11).plus(item.DETPARPRE_12)
    
    this.detpartipresupuestoarray[index].DETPARPRE_TOTAL =this.utilitariosService.formatear(sumatotal,2)
      // Number(
      //   Number(item.DETPARPRE_01) + Number(item.DETPARPRE_02) + Number(item.DETPARPRE_03) + Number(item.DETPARPRE_04) +
      //   Number(item.DETPARPRE_05) + Number(item.DETPARPRE_06) + Number(item.DETPARPRE_07) + Number(item.DETPARPRE_08) +
      //   Number(item.DETPARPRE_09) + Number(item.DETPARPRE_10) + Number(item.DETPARPRE_11) + Number(item.DETPARPRE_12)
      // ).toFixed(2)
  }
  eliminarregistrodet(item) {
    return this.http.post<any[]>(this.way + '/cont/parpre/7565695d4d7774000000', {
      elementos: {
        p_encparpre_anio: item.ENCPARPRE_ANIO,
        p_detparpre_numero: item.DETPARPRE_NUMERO,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
